import NiceModal, { useModal } from '@ebay/nice-modal-react';
import PropTypes from 'prop-types';

import { useState } from 'react';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import { useNavigateSearch } from 'hooks/useNavigateSearch';

import PATHS from 'utils/paths';

import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

import * as S from '../OnlineStores/OnlineStores.styled';
import { setSalesChannel } from '../salesChannelDetailsSlice';
import ConnectionWayCard from './ConnectionWaysCard';

const ConnectionWaysModal = NiceModal.create(({ connectionWays }) => {
	const modal = useModal();
	const navigateSearch = useNavigateSearch();
	const dispatch = useDispatch();
	const [selectedWay, setSelectedWay] = useState(null);

	const handleCancel = () => {
		modal.remove();
	};

	const handleContinue = () => {
		dispatch(setSalesChannel(selectedWay));
		modal.remove();
		navigateSearch(`${PATHS.SALES_CHANNELS}/${selectedWay?.slug}`);
	};

	return (
		<Modal maxWidth="small" fullwidth className="modal-chooseConnectionWay">
			<ModalTitle>
				<Typography variant="p1">chooseConnectionWay</Typography>
			</ModalTitle>
			<ModalContent>
				<S.ConnectionWaysContainer>
					<S.ConnectionWaysButtonContainer>
						{connectionWays?.map((connectionWay) => (
							<ConnectionWayCard
								key={connectionWay.ID}
								connectionWay={connectionWay}
								isSelected={selectedWay?.ID === connectionWay.ID}
								onSelect={setSelectedWay}
							/>
						))}
					</S.ConnectionWaysButtonContainer>
				</S.ConnectionWaysContainer>
			</ModalContent>
			<ModalActions>
				<Button label="cancel" onClick={handleCancel} variant="outline" />
				<Button
					onClick={handleContinue}
					disabled={!selectedWay?.ID}
					icon={faAngleRight}
					iconPos="right"
					label="continue"
					variant="blue"
				/>
			</ModalActions>
		</Modal>
	);
});

ConnectionWaysModal.propTypes = {
	connectionWays: PropTypes.arrayOf(
		PropTypes.shape({
			ID: PropTypes.string.isRequired,
			icon: PropTypes.string.isRequired,
			integrationName: PropTypes.string.isRequired,
			description: PropTypes.string.isRequired,
			badge: PropTypes.string,
			name: PropTypes.string.isRequired
		})
	)
};

export default ConnectionWaysModal;
